import React from 'react';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';
import FarmerGrowthChart from '../FarmerArea/FarmerGrowthChart';

const FarmerArea = () => {
    const distID = localStorage.getItem('distributorId');
    const { data, error, isLoaded } = GetRequest(`/Farmer/GetTalukaWiseFarmerDetails/${distID}`);
    const { data: growthData, error: growthError, isLoaded: growthLoaded } = GetRequest(`/Farmer/GetTalukaGrowthStats/${distID}`);
    const { data: monthlyStats, error: monthlyError, isLoaded: monthlyLoaded } = GetRequest(`/Farmer/GetFarmerStatsForDistributorArea/${distID}`);

    if (error || growthError || monthlyError) {
        return <Error data="Farmers" />;
    }
    if (!isLoaded || !growthLoaded || !monthlyLoaded) {
        return <Loading />;
    }

    const bgColors = ["bg-info", "bg-success", "bg-warning", "bg-danger"];

    return (
        <section className="content">
            <div className="container-fluid FIArea">

                {/* Taluka Wise Farmer Details */}
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-info">
                                <h5 className="card-title">Farmers</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {data.result && data.result.map((taluka, index) => (
                                        <div className="col-md-3 col-sm-6 col-12" key={taluka.talukaId}>
                                            <div className="info-box">
                                                <span className={`info-box-icon ${bgColors[index % bgColors.length]}`}>
                                                    <i className="fa fa-group"></i>
                                                </span>
                                                <div className="info-box-content">
                                                    <span className="info-box-text">{taluka.talukaName}</span>
                                                    <span className="info-box-number">{taluka.numberOfFarmers.toLocaleString()}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Farmer Growth Section */}

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-warning">
                                <h5 className="card-title text-white">📈 Farmers Growth In Your Area</h5>
                            </div>
                            <div className="card-body">
                                {growthData.result && growthData.result.map((growth, index) => (
                                    <div className="row mb-3" key={growth.talukaID}>
                                        <div className="col-12">
                                            <div className="card shadow-sm border rounded">
                                                <div className="card-body">

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        {/* Taluka Name - Left Side */}
                                                        <h4 className="card-title fw-bold text-dark">
                                                            <i className="fa fa-map-marker text-danger me-2 fs-5"></i>
                                                            <span className="text-primary fs-5">{growth.talukaName}</span>
                                                        </h4>

                                                        {/* Date Range - Right Side */}
                                                        <div className="text-end">
                                                            <p className="small text-primary fw-bold fst-italic">
                                                                <i className="fa fa-calendar me-1 text-dark fs-5"></i>
                                                                <span className="text-dark fs-6">{growth.firstMonthYear.replace('-', ' ')} - {growth.lastMonthYear.replace('-', ' ')}</span>
                                                            </p>
                                                        </div>
                                                    </div>




                                                    {/* Highlighted Growth Numbers */}
                                                    <div className="row text-center">
                                                        <div className="col-md-3 col-sm-6">
                                                            <h3 className="fw-bold text-primary">+{growth.last1MonthsIncrease}</h3>
                                                            <p className="small text-secondary">Last 1 Month</p>
                                                            <p className="fw-bold text-success">{growth.last1MonthsPercentageIncrease}% ↑</p>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6">
                                                            <h3 className="fw-bold text-success">+{growth.last3MonthsIncrease}</h3>
                                                            <p className="small text-secondary">Last 3 Months</p>
                                                            <p className="fw-bold text-success">{growth.last3MonthsPercentageIncrease}% ↑</p>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6">
                                                            <h3 className="fw-bold text-warning">+{growth.last6MonthsIncrease}</h3>
                                                            <p className="small text-secondary">Last 6 Months</p>
                                                            <p className="fw-bold text-success">{growth.last6MonthsPercentageIncrease}% ↑</p>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6">
                                                            <h3 className="fw-bold text-danger">+{growth.last12MonthsIncrease}</h3>
                                                            <p className="small text-secondary">Last 12 Months</p>
                                                            <p className="fw-bold text-success">{growth.last12MonthsPercentageIncrease}% ↑</p>
                                                        </div>
                                                    </div>

                                                    {/* Overall Growth */}
                                                    <hr />
                                                    <h5 className="fw-bold text-center text-dark">
                                                        Total Farmers: <span className="text-secondary">{growth.firstMonthFarmers}</span> ➝ <span className="text-success">{growth.currentMonthFarmers}</span>
                                                    </h5>
                                                    <p className="text-center fw-bold text-success">
                                                        Overall Increase: {growth.percentageIncrease}% 🚀
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Farmer Growth Chart Section */}
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-warning">
                                <h5 className="card-title">Growth in Numbers</h5>
                            </div>
                            <div className="card-body">
                                <FarmerGrowthChart data={monthlyStats.result} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FarmerArea;
